import { apiClient } from './clienteHttp';

export interface Usuario {
  email: string;
  enabled: boolean;
  status: string;
  created: string;
  last_modified: string;
  nombre: string;
  nombre_empresa: string;
  rfc: string;
  role: string;
  last_login: string;
  groups: string[];
}

export interface ListUsuariosResponse {
  usuarios: Usuario[];
  next_token?: string;
  count: number;
}

export async function getUsuarios(search?: string): Promise<ListUsuariosResponse> {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  const res = await apiClient.get(`/usuarios?${params.toString()}`);
  return res.data;
}

function encodeEmail(email: string): string {
  return btoa(email).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export async function getUsuario(email: string): Promise<{ usuario: Usuario }> {
  const res = await apiClient.get(`/usuarios/${encodeEmail(email)}`);
  return res.data;
}

export async function crearUsuario(data: {
  email: string;
  nombre: string;
  nombre_empresa: string;
  rfc: string | string[];
  role?: string;
}): Promise<{ message: string; usuario: Usuario }> {
  const res = await apiClient.post('/usuarios', data);
  return res.data;
}

export async function actualizarUsuario(
  email: string,
  data: Partial<Pick<Usuario, 'nombre' | 'nombre_empresa' | 'role'>> & { rfc?: string | string[] },
): Promise<{ message: string }> {
  const res = await apiClient.patch(`/usuarios/${encodeEmail(email)}`, data);
  return res.data;
}

export async function cambiarGrupo(email: string, group: string): Promise<{ message: string }> {
  const res = await apiClient.post(`/usuarios/${encodeEmail(email)}/grupo`, { group });
  return res.data;
}

export async function quitarGrupo(email: string, group: string): Promise<{ message: string }> {
  const res = await apiClient.delete(`/usuarios/${encodeEmail(email)}/grupo`, {
    data: { group },
  });
  return res.data;
}

export async function resetPassword(email: string): Promise<{ message: string }> {
  const res = await apiClient.post(`/usuarios/${encodeEmail(email)}/reset-password`);
  return res.data;
}

export async function toggleEstado(email: string, enabled: boolean): Promise<{ message: string }> {
  const res = await apiClient.post(`/usuarios/${encodeEmail(email)}/estado`, { enabled });
  return res.data;
}

export async function eliminarUsuario(email: string): Promise<{ message: string }> {
  const res = await apiClient.delete(`/usuarios/${encodeEmail(email)}`);
  return res.data;
}
